import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ size = 'default', linkTo = '/', dark = false }) => {
  const sizes = {
    small: { text: 'text-lg', img: 28 },
    default: { text: 'text-xl', img: 34 },
    large: { text: 'text-2xl', img: 42 },
  };
  const { text, img } = sizes[size] || sizes.default;

  const LogoContent = () => (
    <div className="flex items-center space-x-2.5" data-testid="logo">
      <img
        src="/logo64.png"
        alt="alphaswapp"
        width={img}
        height={img}
        style={{ width: img, height: img }}
        className={`rounded-xl ${dark ? '' : 'border border-gray-200'}`}
      />
      <span className={`${text} font-extrabold tracking-tight ${dark ? 'text-white' : 'text-[#191C1F]'}`} style={{ fontFamily: 'Manrope' }}>
        alphaswapp
      </span>
    </div>
  );

  if (linkTo) {
    return <Link to={linkTo} className="hover:opacity-80 transition-opacity"><LogoContent /></Link>;
  }
  return <LogoContent />;
};

export default Logo;
